import { render, staticRenderFns } from "./Started.vue?vue&type=template&id=367ea1be&scoped=true&"
import script from "./Started.vue?vue&type=script&lang=js&"
export * from "./Started.vue?vue&type=script&lang=js&"
import style0 from "./Started.vue?vue&type=style&index=0&id=367ea1be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ea1be",
  null
  
)

export default component.exports